import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  LucideAngularModule,
  Save,
  X,
  Send,
  Pencil,
  ClipboardList,
} from 'lucide-angular';
import { QuestionEditService } from './question-edit.service';
import { QuestionEditContentComponent } from './question-edit-content/question-edit-content';
import { RubricContentComponent } from './rubric-content/rubric-content';

@Component({
  selector: 'app-edit-question-sheet',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LucideAngularModule,
    QuestionEditContentComponent,
    RubricContentComponent,
  ],
  providers: [QuestionEditService],
  templateUrl: './edit-question-sheet.html',
  styleUrl: './edit-question-sheet.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditQuestionSheetComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly service = inject(QuestionEditService);

  protected readonly icons = { Save, X, Send, Pencil, ClipboardList };
  protected activeTab: 'edit' | 'rubric' = 'edit';

  constructor() {
    this.service.stateChanged$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.cdr.markForCheck());
  }

  protected switchTab(tab: 'edit' | 'rubric'): void {
    this.activeTab = tab;
    this.cdr.markForCheck();
  }
}
